import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import TitleService from "../../controller/TitleController/TitleController";
import CreateTitle from './CreateTitle';
import ConfirmationModal from "../../../Setup/views/ConfirmationModal";
import HelpSite from "../../../Common/HelpLink";
import Cookies from "js-cookie";
function TitleListPage() {
    const navigate = useNavigate();
    const [titles, setTitles] = useState([]);
    const { theme } = useContext(ThemeContext);
    const [isLoading, setIsLoading] = useState(true);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentTitle, setCurrentTitle] = useState(null); // To hold the team being edited


    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");

    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const setSortConfigInCookie = (config) => {
        Cookies.set(`TeamSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`TeamSort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };


    const fetchTitle = async (page, size) => {
        try {
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();
            const titleList = await TitleService.GetAllTitle(redirectCallback, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setTitles(titleList);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    useEffect(() => {
        fetchTitle(currentPage, pageSize);

    }, [currentPage, pageSize]);
    useEffect(() => {
        fetchTitle(currentPage, pageSize);

    }, [sortConfig]);


    useEffect(() => {
        setModalInstance(new window.bootstrap.Modal(document.getElementById('titleModal')));

    }, []);

    const handleCreateTitleClick = () => {
        setCurrentTitle(null); // Reset the current team being edited
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleCloseModal = () => {
        if (modalInstance) {
            modalInstance.hide();
        }
    };
    const handleSuccess = () => {
        fetchTitle(currentPage, pageSize);
    };



    const handleEditClick = (title) => {
        setCurrentTitle(title); // Set the team to be edited
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleDeleteClick = async (ID) => {
        const confirmed = window.confirm("Are you sure you want to delete this team?");
        if (confirmed) {
            try {
                await TitleService.DeleteTitle(ID);
                fetchTitle(currentPage, pageSize); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Team:', error);
            }
        }
    };


    const HelpLink = localStorage.getItem('HelpLink');

    const tableRef = useRef();

    const defaultColumns = [
        "Title"
    ];
    const defaultColumnsForSearch = [
        "Title"

    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnOptions = [
        { value: "Title", label: "Title" }

    ];
    const columnSearchOptions = [
        { value: "Title", label: "Title" },

    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`TitleColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`TitleColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };

    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page


        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";

        setSearchOptions(columnsToSearch);
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        const locationData = await TitleService.GetAllTitle(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setTitles(locationData);

    };
    const handleSort = async (key) => {

        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);
        //   const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
        const query = searchQuery.toLowerCase();
        const locationData = await TitleService.GetAllTitle(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setTitles(locationData);

    };
    return (
        <div>
            <div className="row"> <div className="col-sm-3">
                <button className='btn btn-primary btn-sm' onClick={handleCreateTitleClick}>
                    <i className="icofont-plus" aria-hidden="true"> Add New</i>
                </button>
            </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Title List" Module="26" />
                </div></div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">
                            <div className="table-responsive">
                                <div className="row mb-3">

                                    <div className="col-sm-1">
                                        <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                            <option value={500}>500</option>
                                            <option value={1000}>1000</option>
                                        </select>
                                    </div>
                                    <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                                    <div className="col-sm-6"></div>
                                    <div className="col-sm-1 d-flex align-items-center justify-content-end">
                                        <span className="me-2">Search</span>


                                    </div>
                                    <div className="col-sm-2 d-flex justify-content-end">
                                        <input
                                            list="recent-searches"
                                            type="text"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            className="form-control me-2"
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleSearchButtonClick();
                                                }
                                            }}
                                        />

                                        <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                                            <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                                        </button>
                                    </div>



                                </div>
                                <table className="table m-0 table-hover">
                                    <thead>
                                        <tr>

                                            <th onClick={() => handleSort('Title')}>Title</th>
                                            <th style={{ "textAlign": "right" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {titles.map((title, index) => (
                                            <tr key={title.ID} onClick={() => handleEditClick(title)}>

                                                <td>{title.Title}</td>
                                                <td style={{ "textAlign": "right" }}>

                                                    <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleDeleteClick(title.ID)}>
                                                        <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CreateTitle title={currentTitle} onClose={handleCloseModal} onSuccess={handleSuccess} />

        </div>
    );
}

export default TitleListPage;
